import React from 'react'
import { getFullFileUrl } from '../../utils/formatData'
import { useSelector } from 'react-redux'

const RestaurantLogo = props => {
    const restaurantInfo = useSelector(state => state.RestaurantReducer)
    return (
        <img
            src={getFullFileUrl(restaurantInfo?.logoPath)}
            alt="logo"
            {...props}
        />
    )
}

export default RestaurantLogo
